export var sendEventToDataLayer = function sendEventToDataLayer(event) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
};
export var sendRegisterSuccessEventToDataLayer = function sendRegisterSuccessEventToDataLayer(_ref) {
  var userId = _ref.userId;
  return sendEventToDataLayer({
    event: 'register_success',
    page: {
      path: '/register-success'
    },
    userId: userId
  });
};